export const API_BASE_URL = 'https://api-linc.sandscode.com';
// export const API_BASE_URL = 'http://localhost:3000';
// export const API_BASE_URL = 'http://127.0.0.1:3000';
